<div class="component-modal-header">
  <span class="modal-title">Linked Sites</span>
</div>
  <div class="modal-body form-modal-body">
  <form>
    <div *ngFor="let site of sitesList">
      <p-checkbox name="groupname" [value]="site.siteId" [label]="site.siteName" [(ngModel)]="selectedValues"></p-checkbox>
      <br>
      <br>
    </div>
  </form>
  <p-footer>
    <button type="button" (click)="onSubmit()" class="btn btn-sm btn-success">Save</button>
    <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
  </p-footer>
</div>
